import Fetch, { serializeQueryString } from 'Util/fetcher';
import { errorLogger } from '@ajaibid/utils';
import { DEFAULT_GET_RESPONSE } from '@config/constanta';
import { dtPortfolioListUrl, dtOrderOpenUrl, dtOrderHistoryUrl } from './_endpoint';

const fetchGet = (url, { query } = {}) =>
  Fetch.get(`${url}${serializeQueryString(query)}`)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: url });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });

// DT Portfolio
export const getDtPortfolioList = () => fetchGet(dtPortfolioListUrl);

// DT Order history list
export const getDtOrderOpen = (query = {}) => fetchGet(dtOrderOpenUrl, { query });
export const getDtOrderHistory = (query = {}) => fetchGet(dtOrderHistoryUrl, { query });
